import * as React from 'react';
import { cn } from '../lib/cn.js';
import { teinte } from '../lib/teinte.js';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** La couleur d'une donnée (un projet) : une pastille devant le texte. */
  color?: string;
}

/** `.etiquette` du kit. */
export function Badge({ color, className, style, children, ...props }: BadgeProps): React.ReactElement {
  return (
    <span
      className={cn('etiquette', color && 'etiquette-point', className)}
      style={{ ...teinte(color, '--etiquette-teinte'), ...style }}
      {...props}
    >
      {children}
    </span>
  );
}
